<!-- 非会员 扫码计分-->
<template>
    <div class="score-table">
        <div v-if="isReady">
            <span class="title"> 第{{round}}轮 对阵表</span><span class="red size18">{{ errorMsg }}</span>
        </div>
        <div  class="custom-table2  guest-table" >  
            <div style="width:60%">
            <el-table class="custom-table"
                v-if="isReady"
                :data="tableData"
                :row-class-name="tableRowClassName"
                border>
                <el-table-column
                    prop="usernameWE"
                    label="东西"   
                    align="center"                 
                >
                </el-table-column>
                <el-table-column
                    prop="deskNo"
                    label="桌号"
                    width="120"
                    align="center"  
                    >
                </el-table-column>
                <el-table-column
                    prop="usernameSN"
                    label="南北"
                    align="center"  
                >
                </el-table-column>  
            </el-table> </div>  
            <div class="qrCode">
                <el-button type="primary" @click="handleSignIn" class="mg-t-20">非会员签到、计分</el-button>
                <qrcode :text="signUrl" class="mg-t-10" v-if="showQrcode"></qrcode>
            </div> 
        </div>      
    </div>
 </template>
 
 <script>
 import Qrcode from '@/components/Qrcode'
import { mapState } from 'vuex'
 export default {
     props:{
        pubId: {
             type: String,
             default: ''
         },
        pubType: {
            type: String,
            default: ''
        }
     },
     components:{
        Qrcode,
     },
     data() {
         return {
            isShow: false,
            dataList: [],
            tableData: [],
            showQrcode: false,
            signUrl: '',
            errorMsg: '',
            isReady: false
         }
     },
     created() {
 
     },
     mounted() {
        
     },
     computed:{
        ...mapState(['round'])
    },
     methods: {
        tableRowClassName({row, rowIndex}){
            // 一桌一种颜色
            if(row.deskNo % 2){
                return 'white-row'
            }else{
                return  'green-row'
            }
        },
         // 对阵查询
         initData(){
            let params = {
                opcode: this.$code.PubArrange,
                i_serial_mark: this.pubId,
                i_round: this.round,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.isShow = true
                    if(result.length > 0) {
                        let newArr   = result.map(item=>{
                        let username = this.pubType === '2'? `${item['选手名称']}/${item['搭档名称']}` : item['选手名称']
                         return{
                             deskNo: item['桌号'],
                             id: item['选手编号'],
                             username: username,
                             phone: item['选手手机号'],
                             company: item['协会（俱乐部）'],
                             userId: item['选手账号'],
                             seat: item['座位'],
                             round: item['第几轮'],
                             partner: item['搭档名称'],
                             status: item['状态']
                         }
                        })
                        let statusErr = newArr.filter(i=>i.status === '未编排')
                        if(statusErr.length >0){
                            this.errorMsg = '有选手未编排，请先去编排设置！' 
                            this.isReady = false                          
                        }else{
                            this.errorMsg = ''
                            this.isReady = true 
                        }
                        this.tableData = this.selectDeskNo(newArr)
                    }else{
                        this.isShow = true
                        // this.$message.error('请先给裁判设置桌号！')
                        this.$message.error('请先去编排设置！')                        
                    }                   
                 }
             })
         },
         selectDeskNo(arr){
             let result = []
             arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo )){
                        let newArr = arr.filter(user => user.deskNo === item.deskNo)
                        let usernameWE = ''
                        let usernameSN = ''
                        if(this.pubType === '1'){
                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username +'/'+ (newArr.filter(i =>  i.seat.includes('西')))[0].username
                            usernameSN = (newArr.filter(i =>  i.seat.includes('南')))[0].username +'/'+ (newArr.filter(i =>  i.seat.includes('北')))[0].username
                        }else{
                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                            usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username
                        }                       
                        result.push({
                            deskNo: item.deskNo,
                            usernameWE: usernameWE,
                            usernameSN: usernameSN,                            
                        })
                 }
             });
             return result
         }, 
        // selectDeskNo(arr){
        //     let result = []
        //     arr.forEach(item => {
        //         if(!result.some(i => i.deskNo === item.deskNo)){
        //             result.push({
        //                 deskNo: item.deskNo,
        //                 users: arr.filter(user => user.deskNo === item.deskNo)
        //             })
        //         }
        //     });
        //     return result
        // },
        handleSignIn(){
            let origin = window.location.origin
            this.signUrl = origin + '/#/sign?id=' + this.pubId + '&type=' + this.pubType
            // console.log('二维码链接',this.signUrl)
            this.showQrcode = true
        },
     }
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
     font-size: 30px;
     margin-bottom: 20px;
 }
 .custom-table >>> .el-table__header-wrapper tr th{
    font-size: 20px;
    color: #000;
}
.el-table >>> .green-row{
    background-color: #bbffbb
  }
  .el-table >>> .white-row{
    background-color: #f0f9eb;
  }
 table {
     width: 50%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 28px;
   }
   tr:nth-child(even) {
     background-color: #bbffbb;
   }
   thead th {
     background-color: #f2f2f2;
     font-size: 30px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   }
.score-table{
    min-height: 500px;
}
.guest-table{
    display: flex;
}
.qrCode{
    margin-left: 20px;
// position: absolute;
// right: 0;
// top: 0;
// z-index: 22;
}
 </style>


// WEBPACK FOOTER //
// src/views/setting/components/setNumber.vue